import {Link} from 'react-router-dom';
import {useParams} from 'react-router-dom';
import {useState,useEffect} from 'react';
import axios from "axios";
import {baseUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function MisMenu(){
   const handleBackup = async () => {
    try {
      const response = await axios.get(baseUrl + 'backup/', {
        responseType: 'blob',
      });
      const backupFile = new Blob([response.data]);
      const downloadLink = document.createElement('a');
      downloadLink.href = URL.createObjectURL(backupFile);
      downloadLink.download = 'backup.sql';
      downloadLink.click();
    } catch (error) {
      console.error('Error taking backup:', error);
    }
  };

  const handleRestore = async (e) => {
    const formData = new FormData();
    formData.append('backup_file', e.target.files[0]);
    try {
      await axios.post(baseUrl + 'restore/', formData);
      alert('Database restored successfully.');
    } catch (error) {
      console.error('Error restoring database:', error);
    }
  };

    return (
        <section className="container mt-4">
            <div className="row nurseInpatient">
                <div className='col-md-12 col-12'>
                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="panel panel-primary">
                    <div className="panel-heading">
                    <h4 className="panel-title" >MIS</h4>
                    </div>
                    </div>
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="btn-group">
                    <button type="button" className="btn btn" onClick={handleBackup}><span >Backup Database</span></button>
                    </div>
                    <div className="btn-group">
                    <input type="file" onChange={handleRestore} />
                    </div>
                    <div className="btn-group">
                    <a href="/mis-collection"><button type="button" className="btn btn"><span >MIS Dashboard</span></button></a></div>

                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="panel panel-primary">
                    <div className="panel-heading">
                    <h4 className="panel-title" >Cashier OP Reports</h4>
                    </div>
                    </div>
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="btn-group">
                    <a href="/payment-detail"><button type="button" className="btn btn"><span >Payment Detail Report</span></button></a></div>
                    <div className="btn-group">
                    <a href="/collection-all"><button type="button" className="btn btn"><span >Collection Detail Report</span></button></a></div>
                    <div className="btn-group">
                    <a href="/collection-credit"><button type="button" className="btn btn"><span >Credit Pay Report</span></button></a></div>
                    <div className="btn-group">
                    <a href="/due-report"><button type="button" className="btn btn"><span >Patient Due Report</span></button></a></div>
                    <div className="btn-group">
                    <a href="/pending-bills"><button type="button" className="btn btn"><span >Pending Bills Report</span></button></a></div>
                    <div className="btn-group">
                    <a href="/collection-op"><button type="button" className="btn btn"><span >OP Collection Report</span></button></a></div>
                    <div className="btn-group">
                    <a href="/collection-lab"><button type="button" className="btn btn"><span >Lab Collection Report</span></button></a></div>
                    <div className="btn-group">
                    <a href="/collection-inv"><button type="button" className="btn btn"><span >Investigation Collection</span></button></a></div>
                    <div className="btn-group">
                    <a href="/collection-min"><button type="button" className="btn btn"><span > Minor Treatm. Collection</span></button></a></div>
                    <div className="btn-group">
                    <a href="/refund-report"><button type="button" className="btn btn"><span >Refund Report</span></button></a></div>
                    <div className="btn-group">
                    <a href="/cons-pay-report"><button type="button" className="btn btn"><span >Consultant Payment Report</span></button></a></div>
                    <div className="btn-group">
                    <a href="/discount-report"><button type="button" className="btn btn"><span >Discount Report</span></button></a></div>
                    <div className="btn-group">
                    <a href="/expense-report"><button type="button" className="btn btn"><span >Expense Report</span></button></a></div>
                    </div>
                    </div>

                                        <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="panel panel-primary">
                    <div className="panel-heading">
                    <h4 className="panel-title" >IP Reports</h4>
                    </div>
                    </div>
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="btn-group">
                    <a href="/payment-detail-ip"><button type="button" className="btn btn"><span >IP Payment Detail Report</span></button></a></div>
                    <div className="btn-group">
                    <a href="/insur-report"><button type="button" className="btn btn"><span >Insurance Report</span></button></a></div>
                    <div className="btn-group">
                    <a href="/admit-list-date"><button type="button" className="btn btn"><span >Admission List Date</span></button></a></div>
                    <div className="btn-group">
                    <a href="/discharge-list-date"><button type="button" className="btn btn"><span >Discharge List Date</span></button></a></div>
                    <div className="btn-group">
                    <a href="/ip-refund-report-view"><button type="button" className="btn btn"><span >Refund Report Date</span></button></a></div>
                    </div>
                    </div>


               </div>
            </div>
        </section>
    )
}

export default MisMenu;